const blockTypes = {
    AUDIO: "audio",
    SPEAKER: "speaker",
    VIDEO: "video",
    SLIDESHOW: "slideshow"
};

export default blockTypes;
